module.exports = __webpack_public_path__ + "static/media/65720021-tJg1wSgs.231b51ba.JPG";